import { useEffect } from "react";
import { Button } from "@/components/UI/Button";
import Toggles from "@/components/UI/Toggles";
import ColorPicker from "@/components/UI/ColorPicker";
import FlashDurationSlider from "@/components/UI/FlashDurationSlider";
import InfoBanner from "@/components/UI/InfoBanner";
import useTableUIStore from "@/store/tableUIStore";
import agGridFlashNotifications from "@/store/notifications/agGridFlashNotifications";
import { useTheme } from "next-themes";

const TablesIndex = () => {
  const { theme } = useTheme();
  const isDark = theme === "dark";

  function hideBackdrop() {
    const modalBg = document.getElementById("modalBackground");
    if (modalBg) modalBg.classList.add("backdrop-hidden");
  }

  function restoreBackdrop() {
    const modalBg = document.getElementById("modalBackground");
    if (modalBg) modalBg.classList.remove("backdrop-hidden");
  }

  useEffect(() => {
    return () => restoreBackdrop();
  }, []);

  // -- ACTION SUMMARY
  const tableStripeTradeBlotterOn = useTableUIStore(
    (state) => state.tableStripeTradeBlotterOn,
  );
  const toggleTableStripeTradeBlotter = useTableUIStore(
    (state) => state.toggleTableStripeTradeBlotter,
  );
  const tradeBlotterColorLight = useTableUIStore(
    (state) => state.tradeBlotterColorLight,
  );
  const tradeBlotterColorDark = useTableUIStore(
    (state) => state.tradeBlotterColorDark,
  );
  const setTradeBlotterColorLight = useTableUIStore(
    (state) => state.setTradeBlotterColorLight,
  );
  const settradeBlotterColorDark = useTableUIStore(
    (state) => state.settradeBlotterColorDark,
  );
  const resetTradeBlotterColors = useTableUIStore(
    (state) => state.resetTradeBlotterColors,
  );
  const tradeBlotterFlashColorLight = useTableUIStore(
    (state) => state.tradeBlotterFlashColorLight,
  );
  const tradeBlotterFlashColorDark = useTableUIStore(
    (state) => state.tradeBlotterFlashColorDark,
  );
  const setTradeBlotterFlashColorLight = useTableUIStore(
    (state) => state.setTradeBlotterFlashColorLight,
  );
  const setTradeBlotterFlashColorDark = useTableUIStore(
    (state) => state.setTradeBlotterFlashColorDark,
  );
  const resetTradeBlotterFlashColors = useTableUIStore(
    (state) => state.resetTradeBlotterFlashColors,
  );
  const triggerTestFlashTradeBlotter = useTableUIStore(
    (state) => state.triggerTestFlashTradeBlotter,
  );

  // -- FLASH DURATIONS
  const tradeBlotterFlashDuration = agGridFlashNotifications(
    (state) => state.tradeBlotterFlashDuration,
  );
  const setTradeBlotterFlashDuration = agGridFlashNotifications(
    (state) => state.setTradeBlotterFlashDuration,
  );
  const creationFlashDuration = agGridFlashNotifications(
    (state) => state.creationFlashDuration,
  );
  const setCreationFlashDuration = agGridFlashNotifications(
    (state) => state.setCreationFlashDuration,
  );
  const pricesFlashDuration = agGridFlashNotifications(
    (state) => state.pricesFlashDuration,
  );
  const setPricesFlashDuration = agGridFlashNotifications(
    (state) => state.setPricesFlashDuration,
  );

  // -- BID/ASK COLOURS (commented out for now — revisit later per LQC-245)
  // const tradeBlotterBidAskEnabled = useTableUIStore(
  //   (state) => state.tradeBlotterBidAskEnabled,
  // );
  // const toggleTradeBlotterBidAsk = useTableUIStore(
  //   (state) => state.toggleTradeBlotterBidAsk,
  // );
  // const tradeBlotterBidColorLight = useTableUIStore(
  //   (state) => state.tradeBlotterBidColorLight,
  // );
  // const tradeBlotterBidColorDark = useTableUIStore(
  //   (state) => state.tradeBlotterBidColorDark,
  // );
  // const tradeBlotterAskColorLight = useTableUIStore(
  //   (state) => state.tradeBlotterAskColorLight,
  // );
  // const tradeBlotterAskColorDark = useTableUIStore(
  //   (state) => state.tradeBlotterAskColorDark,
  // );
  // const setTradeBlotterBidColorLight = useTableUIStore(
  //   (state) => state.setTradeBlotterBidColorLight,
  // );
  // const setTradeBlotterBidColorDark = useTableUIStore(
  //   (state) => state.setTradeBlotterBidColorDark,
  // );
  // const setTradeBlotterAskColorLight = useTableUIStore(
  //   (state) => state.setTradeBlotterAskColorLight,
  // );
  // const setTradeBlotterAskColorDark = useTableUIStore(
  //   (state) => state.setTradeBlotterAskColorDark,
  // );
  // const resetTradeBlotterBidAskColors = useTableUIStore(
  //   (state) => state.resetTradeBlotterBidAskColors,
  // );

  // -- PRICES
  const tableStripePricesOn = useTableUIStore(
    (state) => state.tableStripePricesOn,
  );
  const toggleTableStripePrices = useTableUIStore(
    (state) => state.toggleTableStripePrices,
  );
  const pricesColorLight = useTableUIStore((state) => state.pricesColorLight);
  const pricesColorDark = useTableUIStore((state) => state.pricesColorDark);
  const setPricesColorLight = useTableUIStore(
    (state) => state.setPricesColorLight,
  );
  const setPricesColorDark = useTableUIStore(
    (state) => state.setPricesColorDark,
  );
  const resetPricesColors = useTableUIStore((state) => state.resetPricesColors);
  const pricesFlashColorLight = useTableUIStore(
    (state) => state.pricesFlashColorLight,
  );
  const pricesFlashColorDark = useTableUIStore(
    (state) => state.pricesFlashColorDark,
  );
  const setPricesFlashColorLight = useTableUIStore(
    (state) => state.setPricesFlashColorLight,
  );
  const setPricesFlashColorDark = useTableUIStore(
    (state) => state.setPricesFlashColorDark,
  );
  const resetPricesFlashColors = useTableUIStore(
    (state) => state.resetPricesFlashColors,
  );
  const triggerTestFlashPrices = useTableUIStore(
    (state) => state.triggerTestFlashPrices,
  );

  // -- TRADE CREATION (uses import settings for stripe)
  const tableStripeImportTableOn = useTableUIStore(
    (state) => state.tableStripeImportOn,
  );
  const toggleTableStripeImport = useTableUIStore(
    (state) => state.toggleTableStripeImport,
  );
  const creationColorLight = useTableUIStore(
    (state) => state.creationColorLight,
  );
  const creationColorDark = useTableUIStore((state) => state.creationColorDark);
  const setCreationColorLight = useTableUIStore(
    (state) => state.setCreationColorLight,
  );
  const setCreationColorDark = useTableUIStore(
    (state) => state.setCreationColorDark,
  );
  const resetCreationColors = useTableUIStore(
    (state) => state.resetCreationColors,
  );
  const creationFlashColorLight = useTableUIStore(
    (state) => state.creationFlashColorLight,
  );
  const creationFlashColorDark = useTableUIStore(
    (state) => state.creationFlashColorDark,
  );
  const setCreationFlashColorLight = useTableUIStore(
    (state) => state.setCreationFlashColorLight,
  );
  const setCreationFlashColorDark = useTableUIStore(
    (state) => state.setCreationFlashColorDark,
  );
  const resetCreationFlashColors = useTableUIStore(
    (state) => state.resetCreationFlashColors,
  );
  const triggerTestFlashCreation = useTableUIStore(
    (state) => state.triggerTestFlashCreation,
  );
  // -- DIRECTION COLOURS (commented out for now — revisit later per LQC-245)
  // const creationDirectionEnabled = useTableUIStore(
  //   (state) => state.creationDirectionEnabled,
  // );
  // const toggleCreationDirection = useTableUIStore(
  //   (state) => state.toggleCreationDirection,
  // );
  // const creationBidPayColorLight = useTableUIStore(
  //   (state) => state.creationBidPayColorLight,
  // );
  // const creationBidPayColorDark = useTableUIStore(
  //   (state) => state.creationBidPayColorDark,
  // );
  // const creationAskReceiveColorLight = useTableUIStore(
  //   (state) => state.creationAskReceiveColorLight,
  // );
  // const creationAskReceiveColorDark = useTableUIStore(
  //   (state) => state.creationAskReceiveColorDark,
  // );
  // const setCreationBidPayColorLight = useTableUIStore(
  //   (state) => state.setCreationBidPayColorLight,
  // );
  // const setCreationBidPayColorDark = useTableUIStore(
  //   (state) => state.setCreationBidPayColorDark,
  // );
  // const setCreationAskReceiveColorLight = useTableUIStore(
  //   (state) => state.setCreationAskReceiveColorLight,
  // );
  // const setCreationAskReceiveColorDark = useTableUIStore(
  //   (state) => state.setCreationAskReceiveColorDark,
  // );
  // const resetCreationDirectionColors = useTableUIStore(
  //   (state) => state.resetCreationDirectionColors,
  // );

  return (
    <div className="flex w-full flex-col space-y-8">
      {/* Action Summary Table */}
      <div className="space-y-1">
        <h3 className="mb-2 flex items-center gap-2 text-sm font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="h-4 w-4"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 013 19.875v-6.75zM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V8.625zM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V4.125z"
            />
          </svg>
          Trade Blotter Table
        </h3>

        <div className="dark:hover:bg-gray-750 ml-8 flex items-center justify-between rounded-lg border border-gray-200 bg-gray-50 px-4 py-3 transition-colors hover:bg-gray-100 dark:border-gray-700 dark:bg-gray-800">
          <div className="flex flex-col">
            <div className="text-base font-medium">Row Colour</div>
            <div className="text-xs text-gray-600 dark:text-gray-400">
              Customise the table row background colour
            </div>
          </div>
          <div className="ml-4 flex-shrink-0">
            <ColorPicker
              color={isDark ? tradeBlotterColorDark : tradeBlotterColorLight}
              onColorChange={
                isDark ? settradeBlotterColorDark : setTradeBlotterColorLight
              }
              onReset={resetTradeBlotterColors}
              onPickerFocus={hideBackdrop}
              onPickerBlur={restoreBackdrop}
            />
          </div>
        </div>

        <div className="dark:hover:bg-gray-750 ml-8 flex items-center justify-between rounded-lg border border-gray-200 bg-gray-50 px-4 py-3 transition-colors hover:bg-gray-100 dark:border-gray-700 dark:bg-gray-800">
          <div className="flex flex-col">
            <div className="text-base font-medium">Notification Flash Colour</div>
            <div className="text-xs text-gray-600 dark:text-gray-400">
              Customise the cell highlight colour when rows flash
            </div>
          </div>
          <div className="ml-4 flex shrink-0 items-center gap-2">
            <Button
              onClick={triggerTestFlashTradeBlotter}
              variant="settingsAction"
              className="mr-2"
            >
              Test
            </Button>
            <ColorPicker
              color={
                isDark
                  ? tradeBlotterFlashColorDark
                  : tradeBlotterFlashColorLight
              }
              onColorChange={
                isDark
                  ? setTradeBlotterFlashColorDark
                  : setTradeBlotterFlashColorLight
              }
              onReset={resetTradeBlotterFlashColors}
              onPickerFocus={hideBackdrop}
              onPickerBlur={restoreBackdrop}
            />
          </div>
        </div>

        <div className="dark:hover:bg-gray-750 ml-8 flex items-center justify-between rounded-lg border border-gray-200 bg-gray-50 px-4 py-3 transition-colors hover:bg-gray-100 dark:border-gray-700 dark:bg-gray-800">
          <div className="flex flex-col">
            <div className="text-base font-medium">Notification Flash Duration</div>
            <div className="text-xs text-gray-600 dark:text-gray-400">
              Control how long table rows flash when notifications occur
            </div>
          </div>
          <FlashDurationSlider
            value={tradeBlotterFlashDuration}
            onChange={setTradeBlotterFlashDuration}
          />
        </div>

        <div className="dark:hover:bg-gray-750 ml-8 flex items-center justify-between rounded-lg border border-gray-200 bg-gray-50 px-4 py-3 transition-colors hover:bg-gray-100 dark:border-gray-700 dark:bg-gray-800">
          <div className="flex flex-col">
            <div className="text-base font-medium">Striped Rows</div>
            <div className="text-xs text-gray-600 dark:text-gray-400">
              Toggle alternating shaded rows on the Action Summary tables
            </div>
          </div>
          <div className="ml-4 flex-shrink-0">
            <Toggles
              checked={tableStripeTradeBlotterOn}
              handleChange={toggleTableStripeTradeBlotter}
            />
          </div>
        </div>

        {/* Bid/Ask Colours — commented out for now, revisit later per LQC-245 */}
        {/* <div className="dark:hover:bg-gray-750 ml-8 flex items-center justify-between rounded-lg border border-gray-200 bg-gray-50 px-4 py-3 transition-colors hover:bg-gray-100 dark:border-gray-700 dark:bg-gray-800">
          <div className="flex flex-col">
            <div className="text-base font-medium">Bid/Ask Colours</div>
            <div className="text-xs text-gray-600 dark:text-gray-400">
              Enable custom colours for bid and ask rows (takes priority over row
              colour)
            </div>
          </div>
          <div className="ml-4 flex-shrink-0">
            <Toggles
              checked={tradeBlotterBidAskEnabled}
              handleChange={toggleTradeBlotterBidAsk}
            />
          </div>
        </div>

        {tradeBlotterBidAskEnabled && (
          <>
            <div className="dark:hover:bg-gray-750 ml-8 flex items-center justify-between rounded-lg border border-gray-200 bg-gray-50 px-4 py-3 transition-colors hover:bg-gray-100 dark:border-gray-700 dark:bg-gray-800">
              <div className="flex flex-col">
                <div className="text-base font-medium">Bid Colour</div>
                <div className="text-xs text-gray-600 dark:text-gray-400">
                  Colour for rows where quoteSideES or quoteSideRP is Bid
                </div>
              </div>
              <div className="ml-4 flex-shrink-0">
                <ColorPicker
                  color={
                    isDark
                      ? tradeBlotterBidColorDark
                      : tradeBlotterBidColorLight
                  }
                  onColorChange={
                    isDark
                      ? setTradeBlotterBidColorDark
                      : setTradeBlotterBidColorLight
                  }
                  onReset={resetTradeBlotterBidAskColors}
                />
              </div>
            </div>

            <div className="dark:hover:bg-gray-750 ml-8 flex items-center justify-between rounded-lg border border-gray-200 bg-gray-50 px-4 py-3 transition-colors hover:bg-gray-100 dark:border-gray-700 dark:bg-gray-800">
              <div className="flex flex-col">
                <div className="text-base font-medium">Ask Colour</div>
                <div className="text-xs text-gray-600 dark:text-gray-400">
                  Colour for rows where quoteSideES or quoteSideRP is Ask
                </div>
              </div>
              <div className="ml-4 flex-shrink-0">
                <ColorPicker
                  color={
                    isDark
                      ? tradeBlotterAskColorDark
                      : tradeBlotterAskColorLight
                  }
                  onColorChange={
                    isDark
                      ? setTradeBlotterAskColorDark
                      : setTradeBlotterAskColorLight
                  }
                  onReset={resetTradeBlotterBidAskColors}
                />
              </div>
            </div>
          </>
        )} */}
      </div>

      {/* Trade Creation Table */}
      <div className="space-y-1">
        <h3 className="mb-2 flex items-center gap-2 text-sm font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="h-4 w-4"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m3.75 9v6m3-3H9m1.5-12H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"
            />
          </svg>
          Trade Creation
        </h3>

        <div className="dark:hover:bg-gray-750 ml-8 flex items-center justify-between rounded-lg border border-gray-200 bg-gray-50 px-4 py-3 transition-colors hover:bg-gray-100 dark:border-gray-700 dark:bg-gray-800">
          <div className="flex flex-col">
            <div className="text-base font-medium">Row Colour</div>
            <div className="text-xs text-gray-600 dark:text-gray-400">
              Customise the table row background colour
            </div>
          </div>
          <div className="ml-4 flex-shrink-0">
            <ColorPicker
              color={isDark ? creationColorDark : creationColorLight}
              onColorChange={
                isDark ? setCreationColorDark : setCreationColorLight
              }
              onReset={resetCreationColors}
              onPickerFocus={hideBackdrop}
              onPickerBlur={restoreBackdrop}
            />
          </div>
        </div>

        <div className="dark:hover:bg-gray-750 ml-8 flex items-center justify-between rounded-lg border border-gray-200 bg-gray-50 px-4 py-3 transition-colors hover:bg-gray-100 dark:border-gray-700 dark:bg-gray-800">
          <div className="flex flex-col">
            <div className="text-base font-medium">Notification Flash Colour</div>
            <div className="text-xs text-gray-600 dark:text-gray-400">
              Customise the cell highlight colour when rows flash
            </div>
          </div>
          <div className="ml-4 flex shrink-0 items-center gap-2">
            <Button
              onClick={triggerTestFlashCreation}
              variant="settingsAction"
              className="mr-2"
            >
              Test
            </Button>
            <ColorPicker
              color={isDark ? creationFlashColorDark : creationFlashColorLight}
              onColorChange={
                isDark ? setCreationFlashColorDark : setCreationFlashColorLight
              }
              onReset={resetCreationFlashColors}
              onPickerFocus={hideBackdrop}
              onPickerBlur={restoreBackdrop}
            />
          </div>
        </div>

        <div className="dark:hover:bg-gray-750 ml-8 flex items-center justify-between rounded-lg border border-gray-200 bg-gray-50 px-4 py-3 transition-colors hover:bg-gray-100 dark:border-gray-700 dark:bg-gray-800">
          <div className="flex flex-col">
            <div className="text-base font-medium">Notification Flash Duration</div>
            <div className="text-xs text-gray-600 dark:text-gray-400">
              Control how long table rows flash when notifications occur
            </div>
          </div>
          <FlashDurationSlider
            value={creationFlashDuration}
            onChange={setCreationFlashDuration}
          />
        </div>

        <div className="dark:hover:bg-gray-750 ml-8 flex items-center justify-between rounded-lg border border-gray-200 bg-gray-50 px-4 py-3 transition-colors hover:bg-gray-100 dark:border-gray-700 dark:bg-gray-800">
          <div className="flex flex-col">
            <div className="text-base font-medium">Striped Rows</div>
            <div className="text-xs text-gray-600 dark:text-gray-400">
              Toggle alternating shaded rows on the Trade Creation table
            </div>
          </div>
          <div className="ml-4 flex-shrink-0">
            <Toggles
              checked={tableStripeImportTableOn}
              handleChange={toggleTableStripeImport}
            />
          </div>
        </div>

        {/* Direction Colours — commented out for now, revisit later per LQC-245 */}
        {/* <div className="dark:hover:bg-gray-750 ml-8 flex items-center justify-between rounded-lg border border-gray-200 bg-gray-50 px-4 py-3 transition-colors hover:bg-gray-100 dark:border-gray-700 dark:bg-gray-800">
          <div className="flex flex-col">
            <div className="text-base font-medium">Direction Colours</div>
            <div className="text-xs text-gray-600 dark:text-gray-400">
              Enable custom colours for direction-based rows (takes priority over
              row colour)
            </div>
          </div>
          <div className="ml-4 flex-shrink-0">
            <Toggles
              checked={creationDirectionEnabled}
              handleChange={toggleCreationDirection}
            />
          </div>
        </div>

        {creationDirectionEnabled && (
          <>
            <div className="dark:hover:bg-gray-750 ml-8 flex items-center justify-between rounded-lg border border-gray-200 bg-gray-50 px-4 py-3 transition-colors hover:bg-gray-100 dark:border-gray-700 dark:bg-gray-800">
              <div className="flex flex-col">
                <div className="text-base font-medium">Sell/Pay Colour</div>
                <div className="text-xs text-gray-600 dark:text-gray-400">
                  Colour for rows where direction is Sell or Pay
                </div>
              </div>
              <div className="ml-4 flex-shrink-0">
                <ColorPicker
                  color={
                    isDark ? creationBidPayColorDark : creationBidPayColorLight
                  }
                  onColorChange={
                    isDark
                      ? setCreationBidPayColorDark
                      : setCreationBidPayColorLight
                  }
                  onReset={resetCreationDirectionColors}
                />
              </div>
            </div>

            <div className="dark:hover:bg-gray-750 ml-8 flex items-center justify-between rounded-lg border border-gray-200 bg-gray-50 px-4 py-3 transition-colors hover:bg-gray-100 dark:border-gray-700 dark:bg-gray-800">
              <div className="flex flex-col">
                <div className="text-base font-medium">Buy/Receive Colour</div>
                <div className="text-xs text-gray-600 dark:text-gray-400">
                  Colour for rows where direction is Buy or Receive
                </div>
              </div>
              <div className="ml-4 flex-shrink-0">
                <ColorPicker
                  color={
                    isDark
                      ? creationAskReceiveColorDark
                      : creationAskReceiveColorLight
                  }
                  onColorChange={
                    isDark
                      ? setCreationAskReceiveColorDark
                      : setCreationAskReceiveColorLight
                  }
                  onReset={resetCreationDirectionColors}
                />
              </div>
            </div>
          </>
        )} */}
      </div>

      {/* Prices Table */}
      <div className="space-y-1">
        <h3 className="mb-2 flex items-center gap-2 text-sm font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="h-4 w-4"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M2.25 18.75a60.07 60.07 0 0115.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 013 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 00-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 01-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 003 15h-.75M15 10.5a3 3 0 11-6 0 3 3 0 016 0zm3 0h.008v.008H18V10.5zm-12 0h.008v.008H6V10.5z"
            />
          </svg>
          Prices Table
        </h3>

        <div className="dark:hover:bg-gray-750 ml-8 flex items-center justify-between rounded-lg border border-gray-200 bg-gray-50 px-4 py-3 transition-colors hover:bg-gray-100 dark:border-gray-700 dark:bg-gray-800">
          <div className="flex flex-col">
            <div className="text-base font-medium">Row Colour</div>
            <div className="text-xs text-gray-600 dark:text-gray-400">
              Customise the table row background colour
            </div>
          </div>
          <div className="ml-4 flex-shrink-0">
            <ColorPicker
              color={isDark ? pricesColorDark : pricesColorLight}
              onColorChange={isDark ? setPricesColorDark : setPricesColorLight}
              onReset={resetPricesColors}
              onPickerFocus={hideBackdrop}
              onPickerBlur={restoreBackdrop}
            />
          </div>
        </div>

        <div className="dark:hover:bg-gray-750 ml-8 flex items-center justify-between rounded-lg border border-gray-200 bg-gray-50 px-4 py-3 transition-colors hover:bg-gray-100 dark:border-gray-700 dark:bg-gray-800">
          <div className="flex flex-col">
            <div className="text-base font-medium">Notification Flash Colour</div>
            <div className="text-xs text-gray-600 dark:text-gray-400">
              Customise the cell highlight colour when rows flash
            </div>
          </div>
          <div className="ml-4 flex shrink-0 items-center gap-2">
            <Button
              onClick={triggerTestFlashPrices}
              variant="settingsAction"
              className="mr-2"
            >
              Test
            </Button>
            <ColorPicker
              color={isDark ? pricesFlashColorDark : pricesFlashColorLight}
              onColorChange={
                isDark ? setPricesFlashColorDark : setPricesFlashColorLight
              }
              onReset={resetPricesFlashColors}
              onPickerFocus={hideBackdrop}
              onPickerBlur={restoreBackdrop}
            />
          </div>
        </div>

        <div className="dark:hover:bg-gray-750 ml-8 flex items-center justify-between rounded-lg border border-gray-200 bg-gray-50 px-4 py-3 transition-colors hover:bg-gray-100 dark:border-gray-700 dark:bg-gray-800">
          <div className="flex flex-col">
            <div className="text-base font-medium">Notification Flash Duration</div>
            <div className="text-xs text-gray-600 dark:text-gray-400">
              Control how long table rows flash when notifications occur
            </div>
          </div>
          <FlashDurationSlider
            value={pricesFlashDuration}
            onChange={setPricesFlashDuration}
          />
        </div>

        <div className="dark:hover:bg-gray-750 ml-8 flex items-center justify-between rounded-lg border border-gray-200 bg-gray-50 px-4 py-3 transition-colors hover:bg-gray-100 dark:border-gray-700 dark:bg-gray-800">
          <div className="flex flex-col">
            <div className="text-base font-medium">Striped Rows</div>
            <div className="text-xs text-gray-600 dark:text-gray-400">
              Toggle alternating shaded rows on the Prices tables
            </div>
          </div>
          <div className="ml-4 flex-shrink-0">
            <Toggles
              checked={tableStripePricesOn}
              handleChange={toggleTableStripePrices}
            />
          </div>
        </div>
      </div>

      {/* Info Section */}
      <div className="space-y-1">
        <h3 className="mb-2 flex items-center gap-2 text-sm font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-4 w-4">
            <path strokeLinecap="round" strokeLinejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
          </svg>
          Info
        </h3>
        <div className="ml-8">
          <InfoBanner title="Theme Colours">
            Colour pickers apply to your current theme ({isDark ? "dark" : "light"}
            ). Switch to {isDark ? "light" : "dark"} mode in the general settings to
            customise those colours.
          </InfoBanner>
        </div>
      </div>
    </div>
  );
};

export default TablesIndex;
